import React, { useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

/**
 * Registers the service worker and, when a new version has been downloaded, asks the user to
 * reload so a stale bundle never lingers (registerType: 'prompt').
 */
const PwaUpdatePrompt = () => {
	const intervalRef = useRef(null);

	useEffect(() => () => clearInterval(intervalRef.current), []);

	const {
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({
		onRegisteredSW(_url, registration) {
			// Check for a new version hourly for long-lived (installed) sessions
			if (!registration) return;
			clearInterval(intervalRef.current);
			intervalRef.current = setInterval(() => registration.update().catch(() => {}), UPDATE_CHECK_INTERVAL_MS);
		},
	});

	if (!needRefresh) return null;

	return (
		<div className="pwa-update-prompt" role="alert" data-testid="pwa-update-prompt">
			<span>A new version of Alert Panel is available.</span>
			<button type="button" className="pwa-update-prompt__action" onClick={() => updateServiceWorker(true)}>
				Reload
			</button>
			<button type="button" className="pwa-update-prompt__dismiss" onClick={() => setNeedRefresh(false)}>
				Later
			</button>
		</div>
	);
};

export default PwaUpdatePrompt;
